"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CABIN_CLASS_TYPES = exports.TravelerSelection = exports.AmenitiesPreference = exports.FieldVisibility = void 0;
__exportStar(require("./enums"), exports);
var FieldVisibility;
(function (FieldVisibility) {
    FieldVisibility["NONE"] = "NONE";
    FieldVisibility["OPTIONAL"] = "OPTIONAL";
    FieldVisibility["REQUIRED"] = "REQUIRED";
})(FieldVisibility = exports.FieldVisibility || (exports.FieldVisibility = {}));
var AmenitiesPreference;
(function (AmenitiesPreference) {
    AmenitiesPreference["NONE"] = "NONE";
    AmenitiesPreference["REQUIRED"] = "REQUIRED";
    AmenitiesPreference["PRE_SELECTED"] = "PRE_SELECTED";
})(AmenitiesPreference = exports.AmenitiesPreference || (exports.AmenitiesPreference = {}));
var TravelerSelection;
(function (TravelerSelection) {
    TravelerSelection["ALWAYS_SPECIFY"] = "ALWAYS_SPECIFY";
    TravelerSelection["LOGGED_USER_FOR_ALL_BOOKERS"] = "LOGGED_USER_FOR_ALL_BOOKERS";
    TravelerSelection["LOGGED_USER_FOR_SIMPLE_BOOKERS"] = "LOGGED_USER_FOR_SIMPLE_BOOKERS";
})(TravelerSelection = exports.TravelerSelection || (exports.TravelerSelection = {}));
exports.CABIN_CLASS_TYPES = {
    ECONOMY: { name: "Econômica", value: "economy" },
    PREMIUM_ECONOMY: { name: "Econômica premium", value: "premium_economy" },
    BUSINESS: { name: "Business", value: "business" },
    FIRST: { name: "Primeira classe", value: "first" },
};
